"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceRecordingTranscriptTriggerEnum = void 0;
var VoiceRecordingTranscriptTriggerEnum;
(function (VoiceRecordingTranscriptTriggerEnum) {
    VoiceRecordingTranscriptTriggerEnum["ClickToTranscript"] = "CLICK_TO_TRANSCRIPT";
    VoiceRecordingTranscriptTriggerEnum["RecordedByJourney"] = "RECORDED_BY_JOURNEY";
    VoiceRecordingTranscriptTriggerEnum["ManuallyRecorded"] = "MANUALLY_RECORDED";
})(VoiceRecordingTranscriptTriggerEnum = exports.VoiceRecordingTranscriptTriggerEnum || (exports.VoiceRecordingTranscriptTriggerEnum = {}));
